export class Links {
  
  public static getLinkToViewBanana = (banana: any, password?: string): string => {
    const params = new URLSearchParams();

    if (password) params.set("p", password);

    const query = params.toString() ? `?${params.toString()}` : "";

    if (banana.isPublic) {
      return `/view-banana/${banana.index}${query}`;
    } else {
      return `/view-banana/id/${banana.id}${query}`;
    }
  }
}